/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/audit-reports-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-reports-api-client";
import type { ExecuteLtxMatchesReportMutationRequest, ExecuteLtxMatchesReportMutationResponse, ExecuteLtxMatchesReportQueryParams, ExecuteLtxMatchesReport400, ExecuteLtxMatchesReport500 } from "../models/ExecuteLtxMatchesReport";

export function getExecuteLtxMatchesReportUrl() {
  const res = { method: 'POST', url: `/reports/ltx-matches/results` as const }
  return res
}

/**
 * @summary Generate report results
 * {@link /reports/ltx-matches/results}
 */
export async function executeLtxMatchesReport(data: ExecuteLtxMatchesReportMutationRequest, params?: ExecuteLtxMatchesReportQueryParams, config: Partial<RequestConfig<ExecuteLtxMatchesReportMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ExecuteLtxMatchesReportMutationResponse, ResponseErrorConfig<ExecuteLtxMatchesReport400 | ExecuteLtxMatchesReport500>, ExecuteLtxMatchesReportMutationRequest>({ method : "POST", url : getExecuteLtxMatchesReportUrl().url.toString(), params, data : requestData, ... requestConfig })
  return res.data
}